import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ZoningIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M2 2V22H22V2H2ZM20 18.5859L13 11.5859V4H20V18.5859ZM4 4H11V11H4V4ZM4 13H11.5859L18.5859 20H4V13Z",
    fill: "currentColor"
  }));
}